import React, { useState, useEffect } from 'react';

const AboutSection = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch('https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/about-section');
        const result = await response.json();
        
        if (!result.success) {
          throw new Error(result.message || 'Failed to fetch data');
        }
        
        setAboutData(result.data);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching about section data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  if (loading) {
    return (
      <>
        
      </>
    );
  }

  if (error) {
    return (
      <section className="why_choose section-padding">
        <div className="container">
          <div className="alert alert-danger" role="alert">
            Error loading content: {error}
          </div>
        </div>
      </section>
    );
  }

  if (!aboutData || !aboutData.isActive) {
    return null; // Don't render if section is inactive
  }

  return (
    <section className="why_choose section-padding">
      <div className="container">
        <div className="row">
          {/* Left Content */}
          <div
            className="col-lg-6 col-sm-12 col-xs-12 wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.1s"
            data-wow-offset={0}
          >
            <div className="wc_content">
              <h2>
                {aboutData.title}{" "}
                <span>{aboutData.highlightedText}</span>
              </h2>
              <p>{aboutData.description}</p>
              <ul>
                {aboutData.features.map((feature, index) => (
                  <li key={index}>
                    <span className="ti-check" />
                    <strong>{feature.text}</strong> {feature.strong}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* Right Image */}
          <div
            className="col-lg-6 col-sm-12 col-xs-12 wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
            data-wow-offset={0}
          >
            <div className="wc_img">
              <img
                src={aboutData.imageUrl}
                className="img-fluid"
                alt={aboutData.imageAlt}
                style={{ borderRadius: "15px" }}
              />
              <div className="wc_year">
                <h3>e-Commerce Product Details Generator</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;